var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:[
    _vm.t,
    {
      c: _vm.clickable,
      selected: _vm.selected,
      highlighted: _vm.highlighted,
      commentary: _vm.highlightCommentaries && _vm.commentaries.length > 0,
      'selected-commentary': _vm.highlightCommentaries && _vm.hasSelectedCommentary,
    } ],on:{"click":_vm.handleClick}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }